import { Input } from '@arcadiapower/shrike';
import { useEffect, useMemo, useState } from 'react';
import { Button } from '~/components/button';
import { setValueByName } from './dev-tools.utils';
// @ts-expect-error TS doesn't like direct JSON imports - need to adjust the tsconfig
import utilityData from './utility-dropdown-data.json';

const funnelUtilities = {
  communityHousingPartners: ['Dominion Energy VA'],
  communitySolar: ['National Grid NY'],
  conference: ['National Grid RI'],
  isolarUcb: ['Central Hudson Gas & Electric'],
  membership: ['Pacific Gas & Electric'],
  oregonTier1: ['Pacific Power OR', 'Portland General Electric'],
  oregonTier2: ['Pacific Power OR', 'Portland General Electric'],
  oregonTier1Lmi: ['Pacific Power OR', 'Portland General Electric'],
  oregonTier2Lmi: ['Pacific Power OR', 'Portland General Electric'],
  solar: ['Baltimore Gas & Electric'],
  solarLandscape: ['Jersey Central Power & Light'],
  telesales: ['National Grid NY'],
  powersetter: ['National Grid NY'],
  sponsoredSolar: ['Ohio Edison'],
  waitlist: ['Public Service Company of NM'],
  mnLmi: ['Xcel Energy MN'],
};

export const AutofillUtilities = ({ funnelId }: { funnelId: string }) => {
  const [inputValue, setInputValue] = useState('');

  const sortedUtilities = useMemo(
    () => sortList(utilityData, funnelUtilities[funnelId]),
    [funnelId],
  );

  useEffect(() => {
    const selected = utilityData.find(u => u.name === inputValue);
    if (selected) setValueByName('zipCode', selected.zip);
  }, [inputValue]);

  return (
    <>
      <Button mode="primary" onClick={() => setValueByName('zipCode', sortedUtilities[0].zip)}>
        {sortedUtilities[0].name}
      </Button>
      <Input
        label="Search utilities"
        list="utilities"
        name="utilityDataList"
        onChange={setInputValue}
        value={inputValue}
      />
      <datalist id="utilities" style={{ width: '100px' }}>
        {sortedUtilities.map(u => (
          <option key={u.id} value={u.name} label={u.name} />
        ))}
      </datalist>
    </>
  );
};

const sortList = (utilityData, funnelUtilities) => {
  const sorted = utilityData.sort((a, b) => b.weight - a.weight);
  return [
    ...sorted.filter(u => (funnelUtilities || []).includes(u.name)),
    ...sorted.filter(u => !(funnelUtilities || []).includes(u.name)),
  ];
};
